module.exports = __webpack_public_path__ + "static/media/image-icon.c0a71249.svg";